import { render, staticRenderFns } from "./orderDetailPay.vue?vue&type=template&id=728ce2bf&scoped=true"
import script from "./orderDetailPay.vue?vue&type=script&lang=js"
export * from "./orderDetailPay.vue?vue&type=script&lang=js"
import style0 from "./orderDetailPay.vue?vue&type=style&index=0&id=728ce2bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728ce2bf",
  null
  
)

export default component.exports